

$(function () {

  $('.js-map-fullscreen').on('click', function() {
    $(this).parent('.js-multimaps-map').toggleClass('fullscreen');
    $(window).trigger('resize');
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/maps.js